import {DatePicker as ArkDatePicker} from '@ark-ui/react/date-picker'
import Icon from '~/components/icon'
import './index.less'

export const DatePickerViewControl = () => {
	return (
		<ArkDatePicker.ViewControl>
			<ArkDatePicker.PrevTrigger>
				<Icon name="arrow-small-left" size={14} />
			</ArkDatePicker.PrevTrigger>
			<ArkDatePicker.ViewTrigger>
				<ArkDatePicker.RangeText />
			</ArkDatePicker.ViewTrigger>
			<ArkDatePicker.NextTrigger>
				<Icon name="arrow-small-right" size={14} />
			</ArkDatePicker.NextTrigger>
		</ArkDatePicker.ViewControl>
	)
}

export const DatePickerViewPrevTrigger = () => {
	return (
		<ArkDatePicker.PrevTrigger>
			<Icon name="arrow-small-left" size={14} />
		</ArkDatePicker.PrevTrigger>
	)
}

export const DatePickerViewNextTrigger = () => {
	return (
		<ArkDatePicker.NextTrigger>
			<Icon name="arrow-small-right" size={14} />
		</ArkDatePicker.NextTrigger>
	)
}
